import { atom } from 'jotai';

type User = {
  id?: string;
  displayName: string;
  email: string;
  avatarUrl?: string;
};

export const userAtom = atom<User | null>(null);
export const authTokenAtom = atom<string | null>(null);
export const isAuthenticatedAtom = atom((get) => !!get(authTokenAtom));
